import React from "react";
import _ from "lodash";

import dataColombia from "../../data/colombia_custom.json";

const departamento = () => {
  const subset = _.map(dataColombia, i =>
    _.pick(i, ["c_digo_dane_del_departamento", "departamento"])
  );
  const uniq = _.uniqWith(subset, _.isEqual);
  return _.orderBy(uniq, "departamento");
};
const municipio = departamento => {
  const municipios = _.map(
    _.filter(dataColombia, { c_digo_dane_del_departamento: departamento })
  );
  return _.orderBy(municipios, "municipio");
};

export default function ExternalField(props) {
  const {
    field: { name, label, options, required },
    i,
    value,
    handleOnChange,
    getParentValue
  } = props;
  if (options.level === 1) {
    const payload = departamento();
    return (
      <div className={`item-${i} form-group`}>
        <label>
          {label}:
          {required ? <span className="required"> *</span> : null}
        </label>
        <select
          name={name}
          value={value}
          onChange={handleOnChange}
          className="form-control"
        >
          <option value="">-- Selecione una opción --</option>
          {_.map(payload, i => (
            <option value={i.c_digo_dane_del_departamento} key={i.departamento}>
              {i.departamento}
            </option>
          ))}
        </select>
      </div>
    );
  } else if (options.level === 2) {
    const dependency = getParentValue(options.dependency);
    const payload = municipio(dependency);
    return (
      <div className={`item-${i} form-group`} key={i}>
        <label>
          {label}:
          {required ? <span className="required"> *</span> : null}
        </label>
        <select
          name={name}
          value={value}
          onChange={handleOnChange}
          className="form-control"
        >
          <option value="">-- Selecione una opción --</option>
          {_.map(payload, item => (
            <option value={item.c_digo_dane_del_municipio} key={item.municipio}>
              {item.municipio}
            </option>
          ))}
        </select>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/User/UserDetailsForm/renderFields/ExternalField.js